export const offer = {
  productName: 'GEOGRAFIA PRONTA™',
  ebookTitle: 'GEOGRAFIA PRONTA™ — Il Percorso Completo di Geografia (dalla 1ª Primaria alla 3ª Media)',
  ebookValue: '50 €',
  bonusValue: '128 €',
  totalValue: '178 €',
  todayPrice: '19 €',
  saving: '159 €',
  discount: '89%',
  guaranteeDays: 30,
}

export const recentBuyers: { name: string; city: string }[] = [
  { name: 'Giulia', city: 'Bologna' },
  { name: 'Marco', city: 'Torino' },
  { name: 'Elena', city: 'Bari' },
  { name: 'Francesca', city: 'Padova' },
  { name: 'Davide', city: 'Palermo' },
  { name: 'Silvia', city: 'Firenze' },
  { name: 'Antonio', city: 'Napoli' },
]
